import { useEffect } from 'react';
import { AppWatch } from '@wajeez-web/core/api-base';
import CohortGraph from 'react-cohort-graph';
import { ChartHeader } from '../ChartHeader';
import {
  useAppwatchSelector,
  useAppwatchDispatch,
  ContentAnalysisActions,
} from '@wajeez-web/stores/appwatch';
import { Card } from '@wajeez-web/components/ui';
import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { ChartsProps } from '../types';

const UserActiveRetentionAfterFirstSessionChart = ({ dates }: ChartsProps) => {
  const dispatch = useAppwatchDispatch();
  const {
    userActiveRetentionAfterFirstSession,
    userActiveRetentionAfterFirstSessionStatus,
  } = useAppwatchSelector((c) => c.contentAnalysis);

  useEffect(() => {
    dispatch(
      ContentAnalysisActions.getUserActiveRetentionAfterFirstSessionAsync({
        fromDate: dates[0].toISOString(),
        toDate: dates[1].toISOString(),
        plan: AppWatch.PlanType.All,
      })
    );
  }, [dates]);

  return (
    <div className="col-span-2">
      {' '}
      <Card>
        <div className="space-y-2 h-[450px]  overflow-auto  scrollbar-thin">
          <ChartHeader
            plansFilterAction={(plan) => {
              dispatch(
                ContentAnalysisActions.getUserActiveRetentionAfterFirstSessionAsync(
                  {
                    fromDate: dates[0].toISOString(),
                    toDate: dates[1].toISOString(),
                    plan: plan,
                  }
                )
              );
            }}
            title="user Active Retention After First Session"
            dates={dates}
          />
          {userActiveRetentionAfterFirstSessionStatus === 'loading' ? (
            <div className="loading h-[300px] flex justify-center items-center align-middle">
              <div className="spinner-border text-primary" role="status">
                <span className="">
                  <ReturnTranslatedText text="general.Loading" />
                </span>
              </div>
            </div>
          ) : (
            <CohortGraph
              data={{
                weeks: Object.fromEntries(
                  userActiveRetentionAfterFirstSession.map((d) => [
                    d.weekOfYear,

                    d.response?.map((ele) => ele.count) || 0,
                  ])
                ),
              }}
              defaultValueType={'value'}
              shadeColor={'#F9A3A4'}
            />
          )}
        </div>
      </Card>
    </div>
  );
};

export default UserActiveRetentionAfterFirstSessionChart;
